/**
 * PROTOTYPE route — throwaway.
 * Question: does the note-card sermon + Someday model feel right?
 * Three layout variants via ?variant=A|B|C (bottom switcher).
 *
 * Open: /prototype/sermon-note-cards
 */
import type { MetaFunction } from '@remix-run/node'
import {
	PrototypeSwitcher,
	usePrototypeVariant,
} from '#app/components/prototype/sermon-note-cards/PrototypeSwitcher'
import {
	VariantA,
	VariantB,
	VariantC,
} from '#app/components/prototype/sermon-note-cards/SermonNoteCardsUI'
import { usePrototypeState } from '#app/components/prototype/sermon-note-cards/usePrototypeState'

export const meta: MetaFunction = () => [
	{ title: 'PROTOTYPE — Sermon note cards' },
]

export default function PrototypeSermonNoteCards() {
	const state = usePrototypeState()
	const variant = usePrototypeVariant()

	return (
		<>
			{variant === 'A' ? <VariantA state={state} /> : null}
			{variant === 'B' ? <VariantB state={state} /> : null}
			{variant === 'C' ? <VariantC state={state} /> : null}
			<PrototypeSwitcher />
		</>
	)
}
